<template>
  <div class="ob1-add-promotional-code ob1-loading">
    <wptv-spinner-undetermined
      :size="24" />
  </div>
</template>

<script>
import WptvSpinnerUndetermined from '../../../spinner/SpinnerUndetermined'

export default {
  name: 'PromotionalCodeSpinner',
  components: {
    WptvSpinnerUndetermined
  }
}
</script>
